import australiaConfig from './releaseInstruction.au.json';
import canadaConfig from './releaseInstruction.ca.json';
import congoConfig from './releaseInstruction.cd.json';
import cameroonConfig from './releaseInstruction.cm.json';
import greatBritainConfig from './releaseInstruction.gb.json';
import honkkongConfig from './releaseInstruction.hk.json';
import jordanConfig from './releaseInstruction.jo.json';
import kenyaConfig from './releaseInstruction.ke.json';
import malaysiaConfig from './releaseInstruction.my.json';
import mozambiqueConfig from './releaseInstruction.mz.json';
import newZealandConfig from './releaseInstruction.nz.json';
import pakistanConfig from './releaseInstruction.pk.json';
import singaporeConfig from './releaseInstruction.sg.json';
import tongoConfig from './releaseInstruction.tg.json';
import bjconfig from  './releaseInstruction.bj.json';
import tanzaniaConfig from './releaseInstruction.tz.json';
import ugandaConfig from './releaseInstruction.ug.json';
import unitedStatesConfig from './releaseInstruction.us.json';
import vietnamConfig from './releaseInstruction.vn.json';
import pilMzConfig from './releaseInstruction.mz.pil.json';
import pilZaConfig from './releaseInstruction.za.pil.json';
import southAfricaConfig from './releaseInstruction.za.json';

export interface ReleaseInstructionCountryConfig {
  country: string;
  fields: {
    docAttachmentRequired?: boolean;
    allowMultipleDocumentUpload?: boolean;
    getOblDetails?: boolean;
    pickupDateRequired?: boolean;
    autoPopulateCFSAndEmptyYard?: boolean;
    carrierHaulageTerminal?: boolean;
    carrierHaulageInputDisabled?: boolean;
    completedStatusTruckerCode?: boolean;
    pickupLocationDateMandate?: boolean;
    pickupLocationRawValue?: boolean;
    carrierHaulageTruckerDisabled?: boolean;
    pickupLocationColumnWide?: boolean;
    pickupLocationColumnWideForPilZa?: boolean;
    intendedDateHidden?: boolean;
    truckerNameColumnShow?: boolean;
    truckerIdColumnShow?: boolean;
    internalCodeColumnShow?: boolean;
    truckerCodeColumnShow?: boolean;
    cntStatusColumnShow?: boolean;
    requestedOnColumnShow?: boolean;
    approvedOnColumnShow?: boolean;
    showReleaseType?: boolean;
    hideSenderEmail?: boolean;
    showPickupLocation?: boolean;
    showPickupLocationAsyncSelect?: boolean;
    showIntendedDateAllContainersAlways?: boolean;
    showIntendedDateAllContainersWhenEditable?: boolean;
    intendedDateEmailRequired?: boolean;
    intendedDateFieldVisible?: boolean;
    intendedDateMyPenang?: boolean;
    showIntendedDateContainerField?: boolean;
    filterCompletedContainers?: boolean;
    showTruckerNameForAllContainer?: boolean;
    showUSCAMessage?: boolean;
    showDocumentAttachmentSection?: boolean;
    requirePickupDateForOverstay?: boolean;
    showMZExtensionField?: boolean;
    useStorageOverstayMessage?: boolean;
    showMalaysiaPODField?: boolean;
    showMalaysiaSpecificLabels?: boolean;
    hideCardBodyForMalaysia?: boolean;
    hideColumnsForUSCA?: boolean;
    hideColumnsForSGVN?: boolean;
    hideColumnsForMalaysiaPOD?: boolean;
    hideColumnsForGBJOAU?: boolean;
    hideColumnsForKETG?: boolean;
    showPickupLocationInTable?: boolean;
    mandatoryTruckerCode?: boolean;
    isPilMZ?:boolean;
    disableEmptyYardWhenUnstuffing?: boolean;
    showDoNumber?: boolean;
    intendedDateAllContainersLabel?: string;
    showDoExtensionInstructionNotes?: boolean;
  };
}

interface CountryConfigEntry {
  default: ReleaseInstructionCountryConfig;
  liners?: {
    // Key is the linerId (e.g. 'MAERSK', 'MSC')
    [linerId: string]: ReleaseInstructionCountryConfig;
  };
}

const countryConfigs: { [countryCode: string]: CountryConfigEntry } = {
  AU: { default: australiaConfig as ReleaseInstructionCountryConfig},
  CA: { default: canadaConfig as ReleaseInstructionCountryConfig },
  CD: { default: congoConfig as ReleaseInstructionCountryConfig },
  CM: { default: cameroonConfig as ReleaseInstructionCountryConfig },
  GB: { default: greatBritainConfig as ReleaseInstructionCountryConfig },
  HK: { default: honkkongConfig as ReleaseInstructionCountryConfig },
  JO: { default: jordanConfig as ReleaseInstructionCountryConfig },
  KE: { default: kenyaConfig as ReleaseInstructionCountryConfig },
  MY: { default: malaysiaConfig as ReleaseInstructionCountryConfig },
  MZ: { default: mozambiqueConfig as ReleaseInstructionCountryConfig,
    liners:{
      '24118': pilMzConfig as ReleaseInstructionCountryConfig
    }
  },
  NZ: { default: newZealandConfig as ReleaseInstructionCountryConfig },
  PK: { default: pakistanConfig as ReleaseInstructionCountryConfig },
  SG: { default: singaporeConfig as ReleaseInstructionCountryConfig },
  TG: { default: tongoConfig as ReleaseInstructionCountryConfig },
  BJ: { default: bjconfig as ReleaseInstructionCountryConfig },
  TZ: { default: tanzaniaConfig as ReleaseInstructionCountryConfig },
  UG: { default: ugandaConfig as ReleaseInstructionCountryConfig },
  US: { default: unitedStatesConfig as ReleaseInstructionCountryConfig },
  VN: { default: vietnamConfig as ReleaseInstructionCountryConfig },
  ZA: { default: southAfricaConfig as ReleaseInstructionCountryConfig, liners:{
      '24118': pilZaConfig as ReleaseInstructionCountryConfig
    } },
};

// Looks up liner-specific config first, falls back to country default
export const getReleaseInstructionCountryConfig = (
  countryCode: string,
  linerId: string
): ReleaseInstructionCountryConfig => {
  const countryEntry = countryConfigs[countryCode];
  if (!countryEntry) return countryConfigs['DEFAULT']?.default;

  return countryEntry.liners?.[linerId] ?? countryEntry.default;
};

export default countryConfigs;